import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { environment } from '@se-po/shared-environments'
import { SeFeTranslationsLoader } from 'se-fe-translations'

@Component({
  selector: 'se-po-unsubscribe-success',
  templateUrl: './unsubscribe-success.component.html',
  styleUrls: ['./unsubscribe-success.component.scss'],
  standalone: false,
})
export class UnsubscribeSuccessComponent implements OnInit {
  public email: string
  public footerYear = new Date().getFullYear()
  public loaded = false
  public orgLogoUrl: string
  public orgName: string
  public seIcon: string

  constructor(
    public route: ActivatedRoute,
    public translateService: TranslateService,
    public seFeTranslationsLoader: SeFeTranslationsLoader,
  ) { }

  public ngOnInit(): void {
    this.loadTranslations()
    this.orgLogoUrl = this.route.snapshot.queryParams?.org_logo_url
    this.orgName = this.route.snapshot.queryParams?.org_name
    this.email = this.route.snapshot.queryParams?.email_address
    this.seIcon = `${environment.uiThemes}/assets/latest/images/se-logos/se-icon.svg`
  }

  public loadTranslations(): void {
    this.seFeTranslationsLoader.load('se-household-setup/feature-unsubscribe-success/assets/translations').then(() => {
      this.loaded = true
    })
  }

  public onClick() {
    window.location.href = `${environment.mySE}/account/communication-prefs`
  }

}
